import { StackProps } from 'rsuite';
import React, { FunctionComponent } from 'react';
import { StackStyled } from './styles';

export interface FlexRowProps extends Omit<StackProps, 'direction'> {
  direction?: 'row' | 'row-reverse';
  fullWidth?: boolean;
  fullHeight?: boolean;
  children: React.ReactNode;
}

export const FlexRow: FunctionComponent<FlexRowProps> = ({ 
  direction = 'row', 
  fullWidth = false,
  fullHeight = false,
  children,
  ...props
}) => {
  return (
    <StackStyled 
      direction={direction} 
      $fullWidth={fullWidth}
      $fullHeight={fullHeight}
      {...props}
    >
      {children}
    </StackStyled>
  );
}
